module.exports = __webpack_public_path__ + "static/media/teamCover.21d14176.webp";